// extracted by mini-css-extract-plugin
module.exports = {"ad":"MobileMPU_ad__nZe12","incontent":"MobileMPU_incontent__LBf0j"};